import { render, staticRenderFns } from "./ClientInfoCard.vue?vue&type=template&id=277e7978&"
import script from "./ClientInfoCard.vue?vue&type=script&lang=js&"
export * from "./ClientInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports